import {useState, useEffect, useRef} from 'react';
import { useSearchParams } from 'react-router-dom';
import Product from '../../../global/Components/Items/Product/Product';
import { getRequest } from '../../../global/utils/apiCall';
import { Row, Col, Spinner } from 'reactstrap';
import PaginationComponent from '../../../global/Components/Pagination/PaginationComponent';
import { Toast } from 'primereact/toast';

const PRODUCTS_URL = 'api/v1/products';

export default function ProductOnSale({userId}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const toast = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [metaData, setMetaData] = useState();
  const [currentPage, setCurrentPage] = useState(searchParams.get('page') || 1);

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const callProducts = async () => {
    setIsLoading(true);
  
    try {
      const response = await getRequest(PRODUCTS_URL,{
        params:{
          user_id: userId,
          page: currentPage && currentPage,
        }
      });
      setProducts(response.data.data);
      setMetaData(response.data.meta);
      setCurrentPage(response.data.meta?.current_page);
      setIsLoading(false);
    }
    catch (error) {
      if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
        showError(error?.response?.data?.message);
      }   
      setIsLoading(false);
    }
    finally{
      setIsLoading(false);
    }
  
    }

    useEffect(() => {
      callProducts();
    },[]);

    useEffect(() => {
      currentPage &&
        currentPage == 1 
          ? searchParams.delete('page')
          : searchParams.set('page', currentPage);
        setSearchParams(searchParams);
        callProducts();
    },[currentPage]);

  return (
    <>
   <Toast ref={toast} position="top-center" />

        {isLoading
            ? <div className='text-center'>
                <Spinner color='primary' className='mx-auto'>
                    Loading...
                </Spinner>
              </div>
            : products.length > 0 
                ? (
                    <div>
                        <Row>
                        {   products.map((product) => (
                                <Col key={product.id} xs={12} sm={6} md={4}>
                                    <Product data={product}></Product>
                                </Col>
                                )
                            )
                        }
                        </Row>
                        <PaginationComponent  currentPage={currentPage} setCurrentPage={setCurrentPage}  metaData={metaData} />
                    </div>
                )
                : (
                    <p className="fw-bold py-4">No Products to display</p>
                )
        }
    </>
  )
}
